<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='$store.state.iconstatus'
                       :showReturn='false'
                       :showEdit="hasBtn('edit-job-position')"
                       :show_del="hasBtn('delete-job-position')"
                       @handleEdit='change'
                       @handleDel='remove'></mrc_ess_iconGroup>
    <positions :isreadonly='readonly'
               @changeReadonly='change'></positions>
  </div>
</template>  

<style scoped>
.icon {
  padding: 15px 10px;
  color: white;
}
.icon-box {
  position: fixed;
  top: 75px;
  right: 30px;
}
.btn-icon {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: primary;
}
.bt1 {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-color: #ccc;
  line-height: 25px;
  text-align: center;
}
.sequenceinput {
  border-top: 1px black solid;
  border-bottom: 1px black solid;
}
</style>

<script> 
import positions from './modules/positions'
import { getDetailsPost, updatePost, deletePost } from '@/service/api/postmanagement.js'
export default {
  components: {
    positions
  },
  props: {},
  data () {
    return {
      readonly: this.$store.state.iconstatus,
    };
  },
  created () { },
  async mounted () {
  },
  methods: {
    change () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', !this.$store.state.iconstatus)  //行内进图标显示
    },
    remove () {  //删除
      this.$myConfirm({
        content: this.$t('message_Confirm_the_deletion')
      }).then(() => {
        deletePost({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'jobs_manage',
              params: {
                type: 'del'
              }
            })
          }
        })
      }).catch(() => { })
    },
  },
  computed: {},
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_posts'
          this.$store.commit('set_page_title', 'label_edit_posts')
        }
        else {
          this.$route.meta.title = 'label_view_posts'
          this.$store.commit('set_page_title', 'label_view_posts')
        }
      }, immediate: true
    }
  },
};
</script>

<style scoped>
</style>
